var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50065 2.5H17.5006C18.4173 2.5 19.1673 3.25 19.1673 4.16667V15.8333C19.1673 16.75 18.4173 17.5 17.5006 17.5H2.50065C1.58398 17.5 0.833984 16.75 0.833984 15.8333V4.16667C0.833984 3.25 1.58398 2.5 2.50065 2.5ZM2.50065 15.8333H17.5007V7.5H10.834V4.16667H2.50065V15.8333Z",
    fill: "#3A4861"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8327 11.6667H8.33268V14.1667H6.66602V11.6667H4.16602V10H6.66602V7.5H8.33268V10H10.8327V11.6667Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTab);
export default __webpack_public_path__ + "static/media/add-tab.6fe0aea93f5d33a3be5ee073f1047d48.svg";
export { ForwardRef as ReactComponent };